import React from 'react';
import EditAgentComponent from '../../../Components/Agent/EditAgent';

export default function EditAgent() {
    return (
        <div className='page-body'>
            <EditAgentComponent />
        </div>
    );
}